import { createAction } from 'redux-actions'

export const fetchProductsList = createAction('FETCH_PRODUCTS_LIST')
export const fetchProductsListSucceed = createAction(
  'FETCH_PRODUCTS_LIST_SUCCEED'
)
export const fetchProductsListFailed = createAction(
  'FETCH_PRODUCTS_LIST_FAILED'
)
